import React, { useState } from 'react';
import { createCtx } from 'src/context/ContextUtils';

type NotifyMessageType = {
  show: boolean;
  message: string;
  type: 'error' | 'success';
};

const defaultNotifyMessage: NotifyMessageType = {
  show: false,
  message: '',
  type: 'error',
};

type ContextNotifyType = {
  notifyMessage: NotifyMessageType;
  setNotifyMessage: React.Dispatch<React.SetStateAction<NotifyMessageType>>;
};

type NotifyProviderProps = {
  children: React.ReactNode;
};

export const [useNotify, ContextNotifyProvider] = createCtx<ContextNotifyType>();

export const NotifyProvider = (props: NotifyProviderProps) => {
  const [notifyMessage, setNotifyMessage] = useState(defaultNotifyMessage);

  return (
    <>
      <ContextNotifyProvider
        value={{
          notifyMessage,
          setNotifyMessage,
        }}
      >
        {props.children}
      </ContextNotifyProvider>
    </>
  );
};
